import { defaultTheme } from 'gd-design-library';
import { font } from './font';

export const textarea = {
  ...defaultTheme.textarea,
  default: {
    ...defaultTheme.textarea.default,
    fontSize: '14px',
    fontFamily: font.family,
  }
};
